<template>
    <div class="iTechLabs">
        <div class="info">
            <div class="pic"></div>
            <div class="name">{{$t('sertificates')}}</div>
        </div>
        <div class="sertificates">
            <img src="/assets/RNG_Blue.gif" alt="" />
            <img src="/assets/RNG_Red.gif" alt="" />
            <img src="/assets/RNG_Green.gif" alt="" />
        </div>
    </div>
</template>

<script>
export default {
  name: 'ITechLabs'
}
</script>

<style lang="scss">
    .webp {
        .iTechLabs{
            .pic {
                background-image: url('/assets/iTech_Logo.png.webp');
            }

            &.gray {
                .pic {
                        background-image: url('/assets/iTech_Logo_Gray.png.webp');
                    }
            }
        }
    }


    .iTechLabs {
        .pic {
            display: block;
            width: 50px;
            height: 50px;
            background: url('/assets/iTech_Logo.png') 0 0 no-repeat;
            background-size: cover;
        }

        &.gray {
           .pic {
                background-image: url('/assets/iTech_Logo_Gray.png');
            }
        }

        .info {
            display: flex;
            align-items: center;
        }

        .name {
            font-size:  1.4rem;
            text-transform: uppercase;
            margin-left: $spacer;
        }

        .sertificates {
            margin-left: -$spacer/2;
            margin-right: -$spacer/2;
            white-space: nowrap;

            img {
                margin: $spacer/2;
            }
        }
    }
</style>
